{
  "actions": "Actions",
  "browserConnect": "Connecter au moyen de Bastion",
  "caeCasVMs": "EAC/EAG - Machines virtuelles du Service d'analyse collaboratif / Environment d'analyse géospatiale (SAC / EAG)",
  "caeVrsVMs": "EAC - Machines virtuelles du Service virtuel de recherche (SVR)",
  "GB": "Go",
  "listOfVMs": "Liste des machines virtuelles",
  "myVMs": "Mes machines virtuelles (MV)",
  "noVms": "Vous n'avez aucune machine virtuelle des SAD.",
  "noVmsP1": "Selon les besoins de votre projet, vos analyses pourraient en tirer profit.",
  "noVmsP2": "Pour initier le processus, appuyez sur « Démarrer un nouveau projet », et nous déterminerons si une machine virtuelle des SAD répondrait à vos besoins.",
  "size": "Taille",
  "startVM": "Démarrer la machine virtuelle",
  "startVMtitle": "Démarrer la MV",
  "status": "État",
  "stopVM": "Arrête la machine virtuelle",
  "stopVMtitle": "Arrêter la MV",
  "VmLoadError1": "Un problème est survenu au moment de charger les machines virtuelles. Veuillez réessayer plus tard ou communiquer avec ",
  "VmLoadErrorLink": "notre équipe de soutien technique",
  "VmLoadError2": " si le problème persiste.",
  "VM": "La MV",
  "VMName": "Nom de la MV",
  "VMStarted": "a démarré avec succès",
  "VMStarting": "démarrage en cours",
  "VMConnected": "s'est connecté avec succès",
  "VMStopping": "en cours d'arrêt (libération)….",
  "VMStopped": "s'est arrêté (libéré) avec succès",
  "creating": "Création en cours",
  "starting": "Démarrage en cours",
  "running": "Exécution en cours",
  "stopping": "En cours d'arrêt",
  "stopped": "Arrêté",
  "deallocating": "Libération",
  "deallocated": "Libéré",
  "updating": "Mise à jour",
  "failed": "Échec",
  "succeeded": "Opération réussie",
  "deleting": "Suppression",
  "migrating": "Migration"
}
